import { useField } from "formik";

import { Select, SelectProps } from "../components/inputs/select/Select";

export interface SelectFormikFieldProps<T extends object>
  extends SelectProps<T> {
  name: string;
  label: SelectProps<T>["label"];
  items?: SelectProps<T>["items"];
  children: SelectProps<T>["children"];
  onSelectionChange?: SelectProps<T>["onSelectionChange"];
  testID: string;
  className?: string;
  info?: SelectProps<T>["info"];
  placeholder?: SelectProps<T>["placeholder"];
  default?: string;
  onChange?: SelectProps<T>["onChange"];
}

export function SelectFormikField<T extends object>(
  props: SelectFormikFieldProps<T>
) {
  const [field, meta, helpers] = useField(props.name);

  return (
    <Select
      className={props.className}
      name={props.name}
      label={props.label}
      selectedKey={field.value ?? props.default ?? null}
      onSelectionChange={(value) => {
        helpers.setValue(value);
        props.onSelectionChange?.(value);
        props.onChange?.(value);
      }}
      onBlur={() => {
        helpers.setTouched(true);
      }}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      isRequired={props.isRequired}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      items={props.items}
      children={props.children}
      description={props.description}
      testID={props.testID}
      info={props.info}
      emptyMessage={props.emptyMessage}
      disabledKeys={props.disabledKeys}
      placeholder={props.placeholder}
    />
  );
}
